import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SoundState {
  selectedSoundKey: string
  LoadingSoundKey: {
    key: string
    loading: boolean
  }
}

const initialState: SoundState = {
  selectedSoundKey: '',
  LoadingSoundKey: {
    key: '',
    loading: false,
  },
}

const soundSlice = createSlice({
  name: 'sound',
  initialState,
  reducers: {
    updateSelectedSoundKey: (state, action: PayloadAction<string>) => {
      state.selectedSoundKey = action.payload
    },
    setLoadingSoundKey: (
      state,
      action: PayloadAction<{ key: string; loading: boolean }>
    ) => {
      state.LoadingSoundKey = action.payload
    },
  },
})

export const { updateSelectedSoundKey, setLoadingSoundKey } = soundSlice.actions
export default soundSlice.reducer
